import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type UsePromotionHistoryResult = ModelHookResult<{
	contributionsFormatted: string;
	impressionsTotal: number;
	impressionsTotalFormatted: string;
	promoterCount: number;
	promoterCountFormatted: string;
	signatureCount: number;
	signatureCountFormatted: string;
	shouldUseDonationLanguage: boolean;
	petitionSlug: string;
}>;

type PetitionFromPageData = ReturnType<typeof useStarterDashboardV2PageData>['data']['petition'];

function getImpressionsStats(petition: PetitionFromPageData): {
	impressionsTotal: number;
	impressionsTotalFormatted: string;
} {
	return {
		impressionsTotal: petition.promotionStats?.impressionsTotal || 0,
		impressionsTotalFormatted: petition.promotionStats?.impressionsTotalLocalized || '0',
	};
}

function getPromoterStats(petition: PetitionFromPageData): {
	promoterCount: number;
	promoterCountFormatted: string;
} {
	return {
		promoterCount: petition.promotionStats?.promoterCount || 0,
		promoterCountFormatted: petition.promotionStats?.promoterCountLocalized || '0',
	};
}

function getSignatureStats(petition: PetitionFromPageData): {
	signatureCount: number;
	signatureCountFormatted: string;
} {
	return {
		signatureCount: petition.promotionStats?.signatureCount || 0,
		signatureCountFormatted: petition.promotionStats?.signatureCountLocalizedCompact || '0',
	};
}

export function usePromotionHistory(): UsePromotionHistoryResult {
	const {
		data: {
			petition,
			featureConfigs: { shouldUseDonationLanguage },
		},
	} = useStarterDashboardV2PageData();

	return {
		data: {
			...getImpressionsStats(petition),
			...getPromoterStats(petition),
			...getSignatureStats(petition),
			contributionsFormatted: petition.promotionStats?.contributionsFormatted || '0',
			shouldUseDonationLanguage,
			petitionSlug: petition.slug,
		},
	};
}
